module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa",
      "error": _vm.errors[_vm.addLanguageSuffix('name')],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('name')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('name'), $$v)
      },
      expression: "form[addLanguageSuffix('name')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opis",
      "error": _vm.errors[_vm.addLanguageSuffix('description')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('description')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('description'), $$v)
      },
      expression: "form[addLanguageSuffix('description')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opis po rozwinięciu",
      "error": _vm.errors[_vm.addLanguageSuffix('details')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('details')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('details'), $$v)
      },
      expression: "form[addLanguageSuffix('details')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tła",
      "error": _vm.errors['bg_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.bg_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "bg_color", $$v)
      },
      expression: "form.bg_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tekstu",
      "error": _vm.errors['text_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.text_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "text_color", $$v)
      },
      expression: "form.text_color"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Bilety dostępne w")])]), _vm._v(" "), _vm._l((_vm.form.periods), function(period, i) {
    return _c('div', {
      staticClass: "ticket-in-periods"
    }, [_c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Okres sprzedaży",
        "error": _vm.errors.periods && _vm.errors.periods[i]['period_id']
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Wybierz okres"
      },
      model: {
        value: (period.period_id),
        callback: function($$v) {
          _vm.$set(period, "period_id", $$v)
        },
        expression: "period.period_id"
      }
    }, _vm._l((_vm.periods), function(option) {
      return _c('el-option', {
        key: option.id,
        attrs: {
          "label": option.name_pl,
          "value": option.id
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "ID w sklepie alter",
        "error": _vm.errors.periods && _vm.errors.periods[i]['external_id']
      }
    }, [_c('el-input', {
      model: {
        value: (period.external_id),
        callback: function($$v) {
          _vm.$set(period, "external_id", $$v)
        },
        expression: "period.external_id"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Cena",
        "error": _vm.errors.periods && _vm.errors.periods[i]['price']
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number"
      },
      model: {
        value: (period.price),
        callback: function($$v) {
          _vm.$set(period, "price", $$v)
        },
        expression: "period.price"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Limit jednorazowo",
        "error": _vm.errors.periods && _vm.errors.periods[i]['limit']
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number"
      },
      model: {
        value: (period.limit),
        callback: function($$v) {
          _vm.$set(period, "limit", $$v)
        },
        expression: "period.limit"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Kolejność (rosnąco)",
        "error": _vm.errors.periods && _vm.errors.periods[i]['order']
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number"
      },
      model: {
        value: (period.order),
        callback: function($$v) {
          _vm.$set(period, "order", $$v)
        },
        expression: "period.order"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "sold-out-input",
      attrs: {
        "label": "Wyprzedany",
        "error": _vm.errors.periods && _vm.errors.periods[i]['sold_out']
      }
    }, [_c('el-switch', {
      model: {
        value: (period.sold_out),
        callback: function($$v) {
          _vm.$set(period, "sold_out", $$v)
        },
        expression: "period.sold_out"
      }
    })], 1)], 1), _vm._v(" "), _c('el-button', {
      staticClass: "remove-button",
      attrs: {
        "size": "mini",
        "icon": "el-icon-close",
        "type": "danger",
        "title": "Usuń"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeItemFromFormset(_vm.form.periods, period)
        }
      }
    })], 1)
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addPeriod
    }
  }, [_vm._v("\n                        Dodaj\n                    ")])], 2)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ed518b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tickets/TicketForm.vue
// module id = 723
// module chunks = 0